import * as tslib_1 from "tslib";
import * as React from 'react';
import { FocusOn as ReactFocusOn } from "./UI";
import sideCar from './sidecar';
export function FocusOn(props) {
    return (React.createElement(ReactFocusOn, tslib_1.__assign({}, props, { sideCar: sideCar })));
}
